module.exports = __webpack_public_path__ + "static/media/麦克纳姆轮机械臂车.558be5f3.png";